var _ = require('underscore');
var SecureMessageWidget = require('./../secure-message/SecureMessageWidget');
var SecureMessageAppointmentView = require('./../ereg/patient-appointments/SecureMessageAppointmentView');
var appointmentConfigurationModel = require('./../appointment-config/appointmentConfigurationModel');

var VIEW_NAME = 'appointmentUpcomingListWidget';

/**
 * Customizations to the SecureMessageWidget specific to the appointments upcoming list page.
 * @class AppointmentUpcomingListWidget
 * @constructor
 * @extends SecureMessageWidget
 */
module.exports = SecureMessageWidget.extend({
  className: SecureMessageWidget.prototype.className + ' index--appointments-upcoming',
  moduleNamespace: VIEW_NAME,

  headerMessageKey: VIEW_NAME + '.header',
  noDataMessageKey: VIEW_NAME + '.noMessages',
  loadingMessageKey: VIEW_NAME + '.loading',
  fetchFailedMessageKey:  VIEW_NAME + '.fetchFailed',

  itemView: SecureMessageAppointmentView,

  /**
   * The MixedMessageCriteria selecting the messages to display.
   *
   * @property criteria {Object}
   *   @property criteria.isPatient {Boolean} username restrictions apply to patient usernames only.
   *   @property criteria.vecnaIds {Array} Array of vecnaId restrictions
   *   @property criteria.appointmentCriteria {Object} AppointmentMessageCriteria - restrictions on appointment messages.
   *     @property criteria.appointmentCriteria.externalAppointmentCriteria {Object} restrictions on the appointment itself.
   *       @property criteria.appointmentCriteria.externalAppointmentCriteria.dateCategory {String} only show appointments that are in the future.
   */
  criteria: function() {
    // Copy the initial criteria so we can modify it.

    var criteria = {
      appointmentCriteria: {
        externalAppointmentCriteria: {
          dateCategory: 'FUTURE'
        }
      },
      // username restrictions apply to patient usernames only
      isPatient: true,
      // no vecnaId restrictions
      vecnaIds: null,
      pagingAndSorting: {
        pageNumber: 0,
        orderingMap: {
          actionDate: true
        },
        pageSize: 7
      }
    };

    // We only want to hide cancelled appointments if the showCanceled Appointments config is off
    if (!appointmentConfigurationModel.get('showCanceledAppointments')) {
      criteria.appointmentCriteria.externalAppointmentCriteria.cancelled = false;
    }
    return criteria;
  },

  initialize: function() {
    _.bindAll(this, 'updateCriteria');
    this.listenTo(appointmentConfigurationModel, 'load-complete', this.updateCriteria);
    appointmentConfigurationModel.loadOnce()
      .then(this.updateCriteria);
    this.listenTo(appointmentConfigurationModel, 'change:showCanceledAppointments', this.updateCriteria);
    SecureMessageWidget.prototype.initialize.apply(this, arguments);
  }
});
